import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { tap,timeout  } from 'rxjs/operators';
import { AuthUtil } from './auth-util';
import { environment } from "../../environments/environment";
import { TokenRequest } from './token-request';
import { Observable } from 'rxjs';
import { AccessToken } from './access-token';

@Injectable()
export class RefreshAuthenticationService {
    
    constructor(private http: HttpClient) { }
       /**
     * Prepare the request to retrive access_token using refresh token
     * @param refresh_token 
     */
    requestForAccessTokenUsingRefreshToken(refresh_token): Observable<AccessToken> {
        let authUtil = new AuthUtil()
    
        let request = new TokenRequest()
        request.client_id = authUtil.base64urlencode(environment.AZURE_BBUI_CLIENT_ID) //'228d410f-af88-4d80-91d0-9674b672d415'
        request.grant_type = authUtil.base64urlencode('refresh_token')
        request.redirect_uri = authUtil.base64urlencode(environment.AZURE_BBUI_REDIRECT_URL_AFTER_LOGIN)//'http%3A%2F%2Flocalhost%3A4200'
        request.code_verifier = authUtil.base64urlencode(localStorage.getItem('pkce_code_verifier'))//'462d7acf7cbd940407fbd361f78e384e9f3e06dd2e9db743661abc97'
        request.refresh_token = authUtil.base64urlencode(refresh_token)
        request.response_type = authUtil.base64urlencode('code')
        request.state = authUtil.base64urlencode(localStorage.getItem('pkce_state'))
        request.scope = authUtil.base64urlencode(environment.AZURE_AUTHORIZATION_SCOPE) //'openid%20profile%20User.Read%20email%20api%3A%2F%2F228d410f-af88-4d80-91d0-9674b672d415%2Faccess.ui'//'user.read%20openid%20profile%20api%3A%2F%2F84c32493-ba89-423e-8b6d-d6997421fad3%2Fbuild.info.authgrant'
        
        return this.retrieveAccessTokenUsingRefreshToken(request)
    }
  
    /**
     * Http post call to retrive access token
     * @param request 
     */
    retrieveAccessTokenUsingRefreshToken(request) {
        let tokenServiceUrl = environment.AZURE_TOKEN_URL //'https://login.microsoftonline.com/' + 'f3983b48-9cf8-4afa-a6fc-e2aaa8c7ec9c/oauth2/v2.0/token'
                       
        let tokenHeader = {
            headers: new HttpHeaders({
                'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
            }) 
        }
  
        let tokenRequestBody = `client_id=${request.client_id}` 
                + `&redirect_uri=${request.redirect_uri}`
                + `&grant_type=${request.grant_type}` 
                + `&refresh_token=${request.refresh_token}`
                + `&scope=${request.scope}`
  
        
        return this.http.post<AccessToken>(tokenServiceUrl, tokenRequestBody, tokenHeader)
                 .pipe(timeout(10000), tap(token => {}, error => {}));
    }
}